import styled, { css } from "styled-components";
import {
  Menu as MenuPrimitive,
  MenuItem as MenuItemPrimitive,
} from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

type OuterListContainerProps = {
  $padding?: number;
};

export const OuterListContainer = styled.div<OuterListContainerProps>`
  ${({ $padding }) => {
    const { tokens } = useDesignTokens();
    const { menu } = tokens;

    return css`
      padding: calc(1px * ${$padding});
      z-index: ${menu.zIndex};
    `;
  }}
`;

export const ListContainer = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { menu } = tokens;

    return css`
      display: grid;
      overflow: hidden;
      border-radius: ${menu.radius};
      border-width: ${menu.stroke.width};
      border-style: ${menu.stroke.style};
      border-color: ${menu.stroke.color};
      box-shadow: 0px 2px 2px ${menu.shadow.outer.color};
    `;
  }}
`;

export const Menu = styled(MenuPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { menu } = tokens;

    return css`
      display: grid;
      gap: ${menu.separator.width};
      background: ${menu.separator.color};
      max-width: ${menu.maxWidth};
    `;
  }}
`;

export const MenuItem = styled(MenuItemPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { menu } = tokens;

    return [
      css`
        display: grid;
        min-height: ${menu.option.minHeight};
        padding: ${menu.option.padding};
        background: ${menu.option.backgroundColor.base};
        cursor: pointer;
        outline: none;
      `,
    ];
  }}
`;

export const MenuItemContentWrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { menu } = tokens;

    return [
      css`
        display: grid;
        align-items: center;
        color: ${menu.option.inner.color.base};
        padding-top: ${menu.option.inner.padding.top};
        padding-left: ${menu.option.inner.padding.left};
        padding-right: ${menu.option.inner.padding.right};
        padding-bottom: ${menu.option.inner.padding.bottom};
        border-radius: ${menu.option.inner.radius};
        background: ${menu.option.inner.backgroundColor.base};
        outline-width: ${menu.option.inner.stroke.width};
        outline-style: ${menu.option.inner.stroke.style};
        outline-color: ${menu.option.inner.stroke.color.base};
        outline-offset: ${menu.option.inner.stroke.offset};
        overflow: hidden;

        ${MenuItem}[data-selected] & {
          background: ${menu.option.inner.backgroundColor.selected};
          outline-color: ${menu.option.inner.stroke.color.selected};
        }

        ${MenuItem}[data-hovered] &,
        ${MenuItem}[data-focus-visible] & {
          background: ${menu.option.inner.backgroundColor.hover};
          outline-color: ${menu.option.inner.stroke.color.hover};
        }

        ${MenuItem}[data-pressed] & {
          background: ${menu.option.inner.backgroundColor.active};
          outline-color: ${menu.option.inner.stroke.color.active};
        }
      `,
    ];
  }}
`;
